import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@fiverr-private/fit';
import FiverrLogo from '@fiverr-private/fit/icons/logos/fiverr_logo_nav';
import * as Translations from '../../providers/i18n';

import './style.scss';

const fiverrUrl = '/?utm_source=external_collaboration';

function ErrorPage({ i18n }) {
    return (
        <div className="collaboration-error-page font-accent">
            <header><a href={fiverrUrl}><span className="logo"><FiverrLogo/></span>{i18n.t('collaboration.error_page.header.what_is_fiverr')}</a></header>
            <div className="error-page-main">
                <div className="icon"/>
                <h3>{i18n.t('collaboration.error_page.title')}</h3>
                <p>{i18n.t('collaboration.error_page.file_not_exist')}</p>
                <Button href={fiverrUrl}>{i18n.t('collaboration.error_page.go_to_fiverr')}</Button>
            </div>
        </div>
    );
}

ErrorPage.propTypes = {
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(ErrorPage);
